
// Adapting adjacently added section colours
(function($) { "use strict";

	//Check last section background, if it is pale green change top footer section to white
	if ( $('.main-content section:last').is('.is-style-bg-color-pale-green')) {
		$('body').addClass('js-white-footer-top');
	}

})(jQuery);